module.exports = __webpack_public_path__ + "img/Taschenlampe.cd70bdb1.webp";